var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "full-page",
        {
          attrs: { options: _vm.options, id: "fullpage" },
          on: { "after-load": _vm.afterLoad, "on-leave": _vm.checkPage }
        },
        [
          _c(
            "div",
            { staticClass: "section section2", attrs: { "data-current": "1" } },
            [
              _c("img", {
                staticClass: "top",
                attrs: { src: "/src/assets/images/1sttop.png", alt: "decal" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mid" }),
              _vm._v(" "),
              _c("img", {
                staticClass: "centering relative",
                attrs: {
                  src: "/src/assets/images/title-text-shadow.png",
                  alt: "decal"
                }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "bottom",
                attrs: { src: "/src/assets/images/1stbot.png", alt: "decal" }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "downbox",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.next)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/black-down.png" }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "section section3", attrs: { "data-current": "2" } },
            [
              _c("div", { staticClass: "header-text first" }, [
                _c("h1", [
                  _vm._v("OUR SIDE: "),
                  _c("span", { staticClass: "tiny" }, [
                    _vm._v(
                      "ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("hr")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "upbox",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.last)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/black-down.png" }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "column" }, [
                  _c("h2", [_vm._v("A COMMON ORIGIN.")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Several hundred years ago, the Apsáalooke [Crow] and Hidatsa were one tribe. During their migration from what is now Canada to new territories, the Crow left to find their own territory in a search that took some hundred years. “Bíiluuke,” meaning “our side” refers to the historical separation of the two tribes."
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { attrs: { id: "video-box-1" } }, [
                    _c("video", { attrs: { controls: "", width: "100%" } }, [
                      _c("source", {
                        attrs: {
                          type: "video/mp4",
                          "data-src": "/src/assets/video/1.mp4"
                        }
                      })
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "footer-arrow",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.next)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/red-down.png" }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "section section4", attrs: { "data-current": "3" } },
            [
              _c("div", { staticClass: "header-text" }, [
                _c("h1", [
                  _vm._v("OUR SIDE: "),
                  _c("span", { staticClass: "tiny" }, [
                    _vm._v(
                      "ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("hr")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "upbox",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.last)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/black-down.png" }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row theme-dark box squeeze" }, [
                _c("div", { staticClass: "column" }, [
                  _c("p", [
                    _vm._v(
                      "Curator Red Star was raised on the Apsáalooke (Crow) Reservation in Montana. Her cultural heritage informs and inspires work that confronts colonial histories and romanticized characterizations of American Indians."
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "“In my curatorial statement, I tell the origin story of the Crow people. The term Bíiluuke, which means, ‘I’m Crow and this is our side,’ describes my approach. I wanted to share this story with each artist, so that they would in turn share their stories and the stories of their people,” says Red Star."
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "The exhibit invites Elisa Harkins, Tanya Lukin Linklater, Marianne Nicolson, and Tanis Maria S’eiltin, to react to the complicated history of colonialism while using the metaphor of thread and stitching to present their personal and tribal histories through a variety of mediums."
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row two theme-dark strip squeeze" }, [
                _c("div", { staticClass: "columm" }, [
                  _c("img", {
                    staticClass: "display-image",
                    attrs: {
                      src:
                        "/src/assets/images/Slikati-Missoula-Photographers-2017-25131932.jpg",
                      alt: "weird vampire shirt.jpg"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column" }, [
                  _c("p", [
                    _vm._v(
                      "Red Star organized the exhibition to honor her commitment, as she says “to create new forums for the expression of Native women’s voices in contemporary art.” The exhibition upholds MAM's dedication to presenting and collecting artworks by contemporary American Indian artists."
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "“[In the exhibition] there’s a lot of different connections—language, global trade, origin stories— and I based the show off of a Crow origin story, and came up with the title Bíiluuke, our side."
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "“To be Bíiluuke—‘OUR SIDE’—implies that one has the same ancestry, language, spiritual beliefs, territory, and social structure. From this term, which my ancestors used to define themselves as a separate unique people, this exhibition, our side, invites four contemporary artists: Elisa Harkins, Tanya Lukin Linklater, Marianne Nicolson, and Tanis S’eiltin to creatively investigate identity, language, and territory from their individual perspectives.”"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "right" }, [
                    _vm._v("—Wendy Red Star, Curator")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "footer-arrow",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.next)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/red-down.png" }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "section section5", attrs: { "data-current": "4" } },
            [
              _c("div", { staticClass: "header-text" }, [
                _c("h1", [
                  _vm._v("OUR SIDE: "),
                  _c("span", { staticClass: "tiny" }, [
                    _vm._v(
                      "ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("hr")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "upbox",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.last)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/black-down.png" }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "gallery box-top" }, [
                _c("div", { staticClass: "gallery-window" }, [
                  _c("img", {
                    attrs: { src: "/src/assets/images/gallery.jpg" }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    attrs: { src: "/src/assets/images/gallery1.jpg" }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    attrs: { src: "/src/assets/images/gallery2.jpg" }
                  }),
                  _vm._v(" "),
                  _c("img", {
                    attrs: { src: "/src/assets/images/gallery3.jpg" }
                  })
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "centering strip bold" }, [
                  _vm._v("Our Side Exhibit and Panel.")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "shoutbox theme-main" }, [
                _c("div", { staticClass: "row box" }, [
                  _c("div", { staticClass: "column centering white" }, [
                    _c("h3", [
                      _vm._v("“The conversation that unfolds during the "),
                      _c("strong", [_vm._v("OUR SIDE")]),
                      _vm._v(
                        " exhibition is one that has been missing, but is one of the most important conversations we could have.”"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", [_vm._v("-Brandon Reintjes, MAM Senior Curator")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "strip" }, [
                      _vm._v(
                        "This exhibition and publication at the Missoula Art Museum have been generously supported by the Andy Warhol Foundation for the Visual Arts."
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "footer-arrow",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.next)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/red-down.png" }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "section section6", attrs: { "data-current": "5" } },
            [
              _c("div", { staticClass: "header-text" }, [
                _c("h1", [
                  _vm._v("OUR SIDE: "),
                  _c("span", { staticClass: "tiny" }, [
                    _vm._v(
                      "ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("hr")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "upbox",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.last)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/black-down.png" }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "column" }, [
                  _c("img", {
                    staticClass: "thumbnail",
                    attrs: { src: "/src/assets/video/thumbnail-2.jpg" },
                    on: {
                      click: function($event) {
                        _vm.play2()
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row two" }, [
                _c("div", { staticClass: "column" }, [
                  _c("h3", { staticClass: "white" }, [
                    _vm._v("OUR SIDE: Panel Discussion Excerpts")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column" }, [
                  _c(
                    "a",
                    {
                      staticClass: "cta",
                      attrs: {
                        href: "https://vimeo.com/259384951/42ae8a820f",
                        target: "_blank"
                      }
                    },
                    [
                      _vm._v("WATCH THE FULL PANEL DISCUSSION"),
                      _c("img", {
                        attrs: { src: "/src/assets/images/black-down.png" }
                      })
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "footer-arrow",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.next)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/blue-down.png" }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "section section7", attrs: { "data-current": "6" } },
            [
              _c("div", { staticClass: "header-text" }, [
                _c("h1", [
                  _vm._v("OUR SIDE: "),
                  _c("span", { staticClass: "tiny" }, [
                    _vm._v(
                      "ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("hr")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "upbox",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.last)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/black-down.png" }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "column" }, [
                  _c("h1", { staticClass: "ani" }, [_vm._v("THE ARTWORK.")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "This reconsideration of the groundbreaking exhibition "
                    ),
                    _c("strong", [
                      _vm._v("Women of Sweetgrass, Cedar and Sage")
                    ]),
                    _vm._v(
                      ", curated by Harmony Hammond and Jaune Quick- to-See Smith on its thirtieth anniversary, offers a re-visitation of the landscape of contemporary American Indian art, and a reconsideration of the opportunities afforded to Native women artists."
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Each artist created work using a broad range of media including performance, sculpture, painting, sound, social engagement and video."
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "qoute" }, [
                    _c("p", [
                      _vm._v(
                        "“The works weave back and forth into each other really beautifully,” says curator Wendy Red Star, “All speak and have a conversation, and there’s room for them also to breathe and speak on their own.”"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("h1", { staticClass: "mate" }, [_vm._v("THE ARTISTS.")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("The artists brought together in "),
                    _c("strong", [_vm._v("OUR SIDE")]),
                    _vm._v(
                      " have, in many important regards, a common bedrock of experience—whether through gender, culture, politics, assimilation or resistance—which informs their discrete artistic practices. These women are,  first and foremost, artists who are highly attuned to the tensions embedded in their work as visual translators of both their contemporary existence and their cultural inheritance. Each, in her own way, navigates a variety of media to express and question and the contested historical meanings of Native identity, geography and home."
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "footer-arrow",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.next)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/red-down.png" }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "section section8", attrs: { "data-current": "7" } },
            [
              _c("div", { staticClass: "header-text" }, [
                _c("h1", [
                  _vm._v("OUR SIDE: "),
                  _c("span", { staticClass: "tiny" }, [
                    _vm._v(
                      "ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("hr")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "upbox",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.last)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/black-down.png" }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "slide" }, [
                _c("div", { staticClass: "row five" }, [
                  _c("div", { staticClass: "three columns" }, [
                    _c("h1", [_vm._v("ELISA HARKINS")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "box justify" }, [
                      _vm._v(
                        "Harkins, a composer and artist originally from Miami, Oklahoma, is an enrolled member of the Muscogee (Creek) Nation. She uses the intersection of performance and lived experience through electronic music, sculpture, and the body to explore subjects such as adoption, enrollment, and the 1990 Indian Arts and Crafts Act."
                      )
                    ]),
                    _vm._v(" "),
                    _c("a", { staticClass: "cta", attrs: { href: "/#7/3" } }, [
                      _vm._v("HEAR A DESCRIPTION OF THE ARTIST’S WORK "),
                      _c("img", {
                        attrs: { src: "/src/assets/images/black-down.png" }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "two columns" }, [
                    _c("img", {
                      staticClass: "display-image",
                      attrs: {
                        src: "/src/assets/images/elisa.jpg",
                        alt: "Elisa Harkins"
                      }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "slide" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "column" }, [
                    _c("img", {
                      staticClass: "thumbnail",
                      attrs: { src: "/src/assets/video/thumbnail-3.jpg" },
                      on: {
                        click: function($event) {
                          _vm.play3()
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row six" }, [
                  _c("div", { staticClass: "three columns" }, [
                    _c("h3", { staticClass: "white" }, [
                      _vm._v("OUR SIDE: Elisa Harkins, Wampum")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "two columns push-one" }, [
                    _c(
                      "a",
                      {
                        staticClass: "cta",
                        attrs: {
                          href: "https://vimeo.com/259384951/42ae8a820f",
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v("WATCH THE FULL VIDEO"),
                        _c("img", {
                          attrs: { src: "/src/assets/images/black-down.png" }
                        })
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "slide" }, [
                _c("div", { staticClass: "row three" }, [
                  _c("div", { staticClass: "column" }, [
                    _c("img", {
                      staticClass: "display-image",
                      attrs: {
                        src: "/src/assets/images/1st.jpg",
                        alt: "Elisa Art"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "two columns" }, [
                    _c("img", {
                      staticClass: "display-image",
                      attrs: {
                        src: "/src/assets/images/elisa-gallery.jpg",
                        alt: "Elisa Gallery"
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "centering strip" }, [
                  _vm._v("Elisa Harkins, "),
                  _c("span", { staticClass: "art" }, [_vm._v("Fake Part 1")]),
                  _vm._v(", fabric, feathers, beads, horsehair, 2014.")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "slide" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "column" }, [
                    _c("img", {
                      staticClass: "thumbnail",
                      attrs: { src: "/src/assets/video/thumbnail-4.jpg" },
                      on: {
                        click: function($event) {
                          _vm.play4()
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row six" }, [
                  _c("div", { staticClass: "three columns" }, [
                    _c("h3", { staticClass: "white" }, [
                      _vm._v("OUR SIDE: Elisa Harkins")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "two columns push-one" }, [
                    _c(
                      "a",
                      {
                        staticClass: "cta",
                        attrs: {
                          href: "https://vimeo.com/259384951/42ae8a820f",
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v("WATCH THE FULL VIDEO"),
                        _c("img", {
                          attrs: { src: "/src/assets/images/black-down.png" }
                        })
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "box artist" }, [
                _c("div", { staticClass: "column centering white" }, [
                  _c("hr"),
                  _c("h2", [_vm._v("Elisa Harkins")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "footer-arrow",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.next)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/red-down.png" }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "section section9", attrs: { "data-current": "8" } },
            [
              _c("div", { staticClass: "header-text" }, [
                _c("h1", [
                  _vm._v("OUR SIDE: "),
                  _c("span", { staticClass: "tiny" }, [
                    _vm._v(
                      "ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("hr")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "upbox",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.last)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/black-down.png" }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "slide" }, [
                _c("div", { staticClass: "row two" }, [
                  _c("div", { staticClass: "column" }, [
                    _c("h1", [_vm._v("TANYA LUKIN LINKLATER")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "box justify" }, [
                      _vm._v(
                        "Linklater, originating from the Native Village of Afognak and Port Lions in southern Alaska and based in northern Ontario, Canada, exhibits her performance collaborations, videos, and installations internationally. Relationships between bodies, histories, poetry, pedagogy, Indigenous conceptual spaces and languages, and institutions are the compelling themes in her work."
                      )
                    ]),
                    _vm._v(" "),
                    _c("a", { staticClass: "cta", attrs: { href: "/#8/3" } }, [
                      _vm._v("HEAR A DESCRIPTION OF THE ARTIST’S WORK "),
                      _c("img", {
                        attrs: { src: "/src/assets/images/black-down.png" }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column" }, [
                    _c("img", {
                      attrs: {
                        src: "/src/assets/images/tanya-1.jpg",
                        alt: "Tanya Art"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Tanya Lukin Linklater, "),
                      _c("span", { staticClass: "art" }, [
                        _vm._v("The treaty is in the body")
                      ]),
                      _vm._v(
                        ", wooden tables, Delica beads, American Spirit cigarettes, 2013–2017."
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "slide middle" }, [
                _c("div", { staticClass: "row seven" }, [
                  _c("div", { staticClass: "three columns" }, [
                    _c("img", {
                      attrs: {
                        src: "/src/assets/images/tanya-2.jpg",
                        alt: "Tanya Art"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "centering strip" }, [
                      _vm._v("Tanya Lukin Linklater, "),
                      _c("span", { staticClass: "art" }, [
                        _vm._v("The Harvest Sturdies")
                      ]),
                      _vm._v(", banners with text, 2013–2017.")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "three push-one columns" }, [
                    _c("img", {
                      attrs: {
                        src: "/src/assets/images/tanya-3.jpg",
                        alt: "Tanya Art"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "centering strip" }, [
                      _vm._v("Tanya Lukin Linklater, "),
                      _c("span", { staticClass: "art" }, [
                        _vm._v("The treaty is in the body")
                      ]),
                      _vm._v(
                        ", wooden tables, Delica beads, American Spirit cigarettes, 2013–2017."
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "slide vert-top" }, [
                _c("div", { staticClass: "row six" }, [
                  _c("div", { staticClass: "four columns push-one" }, [
                    _c("div", { staticClass: "gallery poems" }, [
                      _c("div", { staticClass: "gallery-window" }, [
                        _c("img", {
                          attrs: { src: "/src/assets/images/poem1.jpg" }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: { src: "/src/assets/images/poem2.jpg" }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: { src: "/src/assets/images/poem3.jpg" }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: { src: "/src/assets/images/poem4.jpg" }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: { src: "/src/assets/images/poem5.jpg" }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: { src: "/src/assets/images/poem6.jpg" }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: { src: "/src/assets/images/poem7.jpg" }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          attrs: { src: "/src/assets/images/poem8.jpg" }
                        })
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "centering strip" }, [
                        _vm._v("Tanya Lukin Linklater, "),
                        _c("span", { staticClass: "art" }, [
                          _vm._v("The Harvest Sturdies")
                        ]),
                        _vm._v(", banners with text, 2013–2017.")
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "slide middle" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "column" }, [
                    _c("img", {
                      staticClass: "thumbnail",
                      attrs: { src: "/src/assets/video/thumbnail-5.jpg" },
                      on: {
                        click: function($event) {
                          _vm.play5()
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row two" }, [
                  _c("div", { staticClass: "column" }, [
                    _c("h3", { staticClass: "white" }, [
                      _vm._v("OUR SIDE: Tanya Lukin Linklater")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column" }, [
                    _c(
                      "a",
                      {
                        staticClass: "cta",
                        attrs: {
                          href: "https://vimeo.com/259384951/42ae8a820f",
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v("WATCH THE FULL PANEL DISCUSSION"),
                        _c("img", {
                          attrs: { src: "/src/assets/images/black-down.png" }
                        })
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "box artist" }, [
                _c("div", { staticClass: "column centering white" }, [
                  _c("hr"),
                  _c("h2", [_vm._v("TANYA LUKIN LINKLATER")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "footer-arrow",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.next)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/red-down.png" }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "section section10",
              attrs: { "data-current": "9" }
            },
            [
              _c("div", { staticClass: "header-text" }, [
                _c("h1", [
                  _vm._v("OUR SIDE: "),
                  _c("span", { staticClass: "tiny" }, [
                    _vm._v(
                      "ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("hr")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "upbox",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.last)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/black-down.png" }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "slide" }, [
                _c("div", { staticClass: "row two" }, [
                  _c("div", { staticClass: "column mobile-second" }, [
                    _c("img", {
                      attrs: {
                        src: "/src/assets/images/marianne-1.jpg",
                        alt: "Marianne Art"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "centering" }, [
                      _vm._v("Marianne Nicolson/‘Tayagila’ogwa, "),
                      _c("span", { staticClass: "art" }, [
                        _vm._v(
                          "La'am'lawisuxw ya'xuxsan's 'nalax (Then the Deluge of Our World Came)"
                        )
                      ]),
                      _vm._v(", acrylic and brass on wood, 2017.")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column mobile-first" }, [
                    _c("h1", [_vm._v("MARIANNE NICOLSON")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "box justify" }, [
                      _vm._v(
                        "Nicolson (‘Tayagila’ogwa), is an artist of Scottish and Dzawada’enuxw First Nations descent. The Dzawada’enuxw People are a member tribe of the Kwakwaka’wakw Nations of the Paci c Northwest Coast. Nicolson’s practice encompasses both traditional Kwakwaka’wakw forms and culture and Western art practice to engage issues of Aboriginal histories and politics arising from a passionate involvement in cultural revitalization and sustainability."
                      )
                    ]),
                    _vm._v(" "),
                    _c("a", { staticClass: "cta", attrs: { href: "/#9/2" } }, [
                      _vm._v("HEAR A DESCRIPTION OF THE ARTIST’S WORK "),
                      _c("img", {
                        attrs: { src: "/src/assets/images/black-down.png" }
                      })
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "slide middle" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "column" }, [
                    _c("img", {
                      attrs: {
                        src: "/src/assets/images/gallery.jpg",
                        alt: "Marianne Art"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "centering strip" }, [
                      _vm._v("Marianne Nicolson/‘Tayagila’ogwa, "),
                      _c("span", { staticClass: "art" }, [
                        _vm._v(
                          "La'am'lawisuxw ya'xuxsan's 'nalax (Then the Deluge of Our World Came)"
                        )
                      ]),
                      _vm._v(", acrylic and brass on wood, 2017.")
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "slide middle" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "column" }, [
                    _c("img", {
                      staticClass: "thumbnail",
                      attrs: { src: "/src/assets/video/thumbnail-6.jpg" },
                      on: {
                        click: function($event) {
                          _vm.play6()
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row two" }, [
                  _c("div", { staticClass: "column" }, [
                    _c("h3", [_vm._v("OUR SIDE: Marianne Nicolson")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column" }, [
                    _c(
                      "a",
                      {
                        staticClass: "cta",
                        attrs: {
                          href: "https://vimeo.com/259384951/42ae8a820f",
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v("WATCH THE FULL PANEL DISCUSSION"),
                        _c("img", {
                          attrs: { src: "/src/assets/images/black-down.png" }
                        })
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "box artist" }, [
                _c("div", { staticClass: "column centering light" }, [
                  _c("hr"),
                  _c("h2", [_vm._v("MARIANNE NICOLSON")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "footer-arrow",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.next)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/red-down.png" }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "section section11",
              attrs: { "data-current": "10" }
            },
            [
              _c("div", { staticClass: "header-text" }, [
                _c("h1", [
                  _vm._v("OUR SIDE: "),
                  _c("span", { staticClass: "tiny" }, [
                    _vm._v(
                      "ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("hr")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "upbox",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.last)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/black-down.png" }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "slide", attrs: { "data-current": "11" } },
                [
                  _c("div", { staticClass: "row two" }, [
                    _c("div", { staticClass: "column mobile-second" }, [
                      _c("img", {
                        attrs: {
                          src: "/src/assets/images/tanis-1.jpg",
                          alt: "Tanis Art"
                        }
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "centering" }, [
                        _vm._v("Tanis Maria S’eiltin, "),
                        _c("span", { staticClass: "art" }, [
                          _vm._v("Untitled")
                        ]),
                        _vm._v(
                          ", merino wool felt, thread, metal grommets and snaps, fresh water pearls, 2017."
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "column mobile-first" }, [
                      _c("h1", [_vm._v("TANIS MARIA S’EILTIN")]),
                      _vm._v(" "),
                      _c("p", { staticClass: "box justify" }, [
                        _vm._v(
                          "S’eiltin grew up in Alaska in a family of artists, where she learned traditional weaving and skin-sewing techniques and is a professor at Western Washington University in Bellingham, WA."
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        { staticClass: "cta", attrs: { href: "/#10/3" } },
                        [
                          _vm._v("HEAR A DESCRIPTION OF THE ARTIST’S WORK "),
                          _c("img", {
                            attrs: { src: "/src/assets/images/black-down.png" }
                          })
                        ]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "slide" }, [
                _c("div", { staticClass: "row seven" }, [
                  _c("div", { staticClass: "two columns" }, [
                    _c("img", {
                      staticClass: "display-image",
                      attrs: {
                        src: "/src/assets/images/tanis-2.jpg",
                        alt: "Tanis Art"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "three columns" }, [
                    _c("img", {
                      staticClass: "display-image no-mobile",
                      attrs: {
                        src: "/src/assets/images/tanis-3.jpg",
                        alt: "Tanis Art"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "two columns" }, [
                    _c("img", {
                      staticClass: "display-image",
                      attrs: {
                        src: "/src/assets/images/tanis-4.jpg",
                        alt: "Tanis Art"
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "centering strip" }, [
                  _vm._v("Tanis Maria S’eiltin, "),
                  _c("span", { staticClass: "art" }, [_vm._v("Untitled")]),
                  _vm._v(
                    ", merino wool felt, thread, metal grommets and snaps, fresh water pearls, 2017."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "slide middle" }, [
                _c("div", { staticClass: "row two" }, [
                  _c("div", { staticClass: "column centering" }, [
                    _c("img", {
                      attrs: {
                        src: "/src/assets/images/tanis-5.jpg",
                        alt: "Tanis Art"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Tanis Maria S’eiltin, "),
                      _c("span", { staticClass: "art" }, [
                        _vm._v("Steam Punk Raven Flies to the North Star")
                      ]),
                      _vm._v(
                        ", wool felt, glass beads, grommets, thread, 2017."
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column centering" }, [
                    _c("img", {
                      attrs: {
                        src: "/src/assets/images/tanis-6.jpg",
                        alt: "Tanis Art"
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("Tanis Maria S’eiltin, "),
                      _c("span", { staticClass: "art" }, [
                        _vm._v("People of the Tide: Raven, Coho, Octopus")
                      ]),
                      _vm._v(
                        ", wool felt, leather, glass beads, grommets, thread, 2017."
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "slide middle" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "column" }, [
                    _c("img", {
                      staticClass: "thumbnail",
                      attrs: { src: "/src/assets/video/thumbnail-7.jpg" },
                      on: {
                        click: function($event) {
                          _vm.play7()
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row two" }, [
                  _c("div", { staticClass: "column" }, [
                    _c("h3", { staticClass: "white" }, [
                      _vm._v("OUR SIDE: Tanis Maria S’eiltin")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column" }, [
                    _c(
                      "a",
                      {
                        staticClass: "cta",
                        attrs: {
                          href: "https://vimeo.com/259384951/42ae8a820f",
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v("WATCH THE FULL PANEL DISCUSSION"),
                        _c("img", {
                          attrs: { src: "/src/assets/images/black-down.png" }
                        })
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "box artist" }, [
                _c("div", { staticClass: "column centering white" }, [
                  _c("hr"),
                  _c("h2", [_vm._v("TANIS MARIA S’EILTIN")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "footer-arrow",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.next)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/blue-down.png" }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "section section12",
              attrs: { "data-current": "11" }
            },
            [
              _c("div", { staticClass: "header-text" }, [
                _c("h1", [
                  _vm._v("OUR SIDE: "),
                  _c("span", { staticClass: "tiny" }, [
                    _vm._v(
                      "ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "upbox",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.last)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/black-down.png" }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row eight" }, [
                _c("div", { staticClass: "six columns push-one" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "http://www.missoulaartmuseum.org/",
                        target: "_blank"
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "logo centering",
                        attrs: { src: "/src/assets/images/logo.png" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "bold" }, [
                    _vm._v("OUR SIDE is a testament to MAM’s purpose.")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "One of MAM’s abiding mottos is “Free Expression//Free Admission.” We believe that freedom of expression, freedom of thought, intellectual inquiry, and cultural expression are the foundation of our democratic values. MAM develops exhibitions that are representations of these principles in action. Cultural work and human rights are closely aligned."
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "MAM is committed to diversity and inclusion as a driver of institutional excellence. MAM seeks out diversity of participation, thought and action."
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "footer-arrow",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.next)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/blue-down.png" }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "section section13",
              attrs: { "data-current": "12" }
            },
            [
              _c("div", { staticClass: "header-text" }, [
                _c("h1", [
                  _vm._v("OUR SIDE: "),
                  _c("span", { staticClass: "tiny" }, [
                    _vm._v(
                      "ELISA HARKINS, TANYA LUKIN LINKLATER, MARIANNE NICOLSON AND TANIS MARIA S’EILTIN"
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "upbox",
                  on: {
                    click: function($event) {
                      _vm.goToPage(_vm.last)
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "/src/assets/images/black-down.png" }
                  })
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "theme-secondary" }, [
                _c("div", { staticClass: "row six box" }, [
                  _c("div", { staticClass: "two columns" }, [
                    _c("img", {
                      staticClass: "display-image",
                      attrs: {
                        src: "/src/assets/images/book.jpg",
                        alt: "Buy the book!"
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "four columns white" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "http://www.missoulaartmuseum.org/index.php/type/catalog/ID/8f2f8c1aa0e4367f9e598f0e73f980af/fuseaction/buy.detail.htm",
                          target: "_blank"
                        }
                      },
                      [
                        _c("h2", { staticClass: "box" }, [
                          _vm._v("ORDER THE BOOK:")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "http://www.missoulaartmuseum.org/index.php/type/catalog/ID/8f2f8c1aa0e4367f9e598f0e73f980af/fuseaction/buy.detail.htm",
                          target: "_blank"
                        }
                      },
                      [
                        _c("h1", [
                          _vm._v(
                            "OUR SIDE: ELISA HARKINS, TANYA LUKIN LINKLATER MARIANNE NICOLSON + TANIS MARIA S’EILTIN"
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", [_vm._v("Curated by Wendy Red Star")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "strip" }, [
                      _vm._v(
                        "Copyright © 2018 Missoula Art Museum | Photography copyright © 2017 "
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "http://slikati.com/",
                            target: "_blank"
                          }
                        },
                        [_vm._v("Slikati Photo + Video")]
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row six box" }, [
                _c("div", { staticClass: "four columns push-one" }, [
                  _c(
                    "a",
                    {
                      staticClass: "cta",
                      attrs: { href: "mailto:brandon@missoulaartmuseum.org" }
                    },
                    [
                      _vm._v(
                        "TO INQUIRE ABOUT THE TOURING EXHIBITION, CLICK HERE."
                      ),
                      _c("img", {
                        attrs: { src: "/src/assets/images/black-down.png" }
                      })
                    ]
                  )
                ])
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: { id: "video-box-2" },
          on: {
            click: function($event) {
              _vm.closemodal()
            }
          }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("i", {
            staticClass: "ion-ios-close-outline",
            attrs: { id: "right" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: { id: "video-box-3" },
          on: {
            click: function($event) {
              _vm.closemodal()
            }
          }
        },
        [
          _vm._m(1),
          _vm._v(" "),
          _c("i", {
            staticClass: "ion-ios-close-outline",
            attrs: { id: "right" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: { id: "video-box-4" },
          on: {
            click: function($event) {
              _vm.closemodal()
            }
          }
        },
        [
          _vm._m(2),
          _vm._v(" "),
          _c("i", {
            staticClass: "ion-ios-close-outline",
            attrs: { id: "right" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: { id: "video-box-5" },
          on: {
            click: function($event) {
              _vm.closemodal()
            }
          }
        },
        [
          _vm._m(3),
          _vm._v(" "),
          _c("i", {
            staticClass: "ion-ios-close-outline",
            attrs: { id: "right" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: { id: "video-box-6" },
          on: {
            click: function($event) {
              _vm.closemodal()
            }
          }
        },
        [
          _vm._m(4),
          _vm._v(" "),
          _c("i", {
            staticClass: "ion-ios-close-outline",
            attrs: { id: "right" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal",
          attrs: { id: "video-box-7" },
          on: {
            click: function($event) {
              _vm.closemodal()
            }
          }
        },
        [
          _vm._m(5),
          _vm._v(" "),
          _c("i", {
            staticClass: "ion-ios-close-outline",
            attrs: { id: "right" }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-content" }, [
      _c("video", { attrs: { controls: "", width: "100%" } }, [
        _c("source", {
          attrs: { "data-src": "/src/assets/video/2.mp4", type: "video/mp4" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-content" }, [
      _c("video", { attrs: { controls: "", width: "100%" } }, [
        _c("source", {
          attrs: { "data-src": "/src/assets/video/3.mp4", type: "video/mp4" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-content" }, [
      _c("video", { attrs: { controls: "", width: "100%" } }, [
        _c("source", {
          attrs: { "data-src": "/src/assets/video/4.mp4", type: "video/mp4" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-content" }, [
      _c("video", { attrs: { controls: "", width: "100%" } }, [
        _c("source", {
          attrs: { "data-src": "/src/assets/video/5.mp4", type: "video/mp4" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-content" }, [
      _c("video", { attrs: { controls: "", width: "100%" } }, [
        _c("source", {
          attrs: { "data-src": "/src/assets/video/6.mp4", type: "video/mp4" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-content" }, [
      _c("video", { attrs: { controls: "", width: "100%" } }, [
        _c("source", {
          attrs: { "data-src": "/src/assets/video/7.mp4", type: "video/mp4" }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-770affdd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-770affdd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Main.vue
// module id = 15
// module chunks = 0